<template>
  <BaseModal
    title="Importação por planilha"
    hook-sufix="DrmUploadModal"
    :disable-default-padding="true"
    :on-close-hook="onCloseHook"
    :on-open-hook="onOpenHook"
    :persistent="false"
    :hide-close-btn="true"
    :min-height="minHeight"
    modal-width="760px"
    :fullscreen="isMobileBreakpoint"
  >
    <template #content>
      <div class="modal-header">
        <div class="d-flex flex-column">
          <span class="body-bold-medium">{{
            $t('message.pages.drm.importCsvModal.title')
          }}</span>
          <span class="body-regular-smaller neutral-40-light--text">
            {{ $t('message.pages.drm.importCsvModal.description') }}
            <a
              target="_blank"
              type="secondary"
              size="xsmall"
              :href="$t('message.pages.drm.drmWatermark.howToUseHref')"
            >
              {{ $t('message.memberGetMember.faqModal.article') }}

              <v-icon size="12">mdi-open-in-new</v-icon>
            </a>
          </span>
        </div>
        <v-btn icon @click="handleClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <div v-if="isLoading" class="skeleton-wrapper">
        <div class="d-flex justify-space-between">
          <div
            v-for="(header, i) in 4"
            :key="'header-' + i"
            style="width: 256px; margin-right: 16px"
          >
            <v-select
              disabled
              :items="fileData[0]"
              style="width: 256px"
              hide-details
              :placeholder="$t('message.actions.select')"
            >
            </v-select>
            <div v-for="n in 8" :key="n" class="skeleton-line" />
          </div>
        </div>
      </div>
      <div v-else-if="fileData.length > 0" class="file-content">
        <div
          class="container-content"
          :style="{ height: isMobileBreakpoint ? '79vh' : 'auto' }"
        >
          <div class="d-flex justify-space-between" style="margin-top: 10px">
            <div
              v-for="(header, i) in fileData[0]"
              :key="'header-' + i"
              style="width: 256px; margin-right: 16px"
            >
              <v-select
                v-model="selectedFields[i]"
                :items="fields"
                :error="isDuplicate(selectedFields[i], i)"
                :placeholder="$t('message.actions.select')"
                item-text="label"
                item-value="value"
                label="Tipo"
                hide-details="auto"
                style="width: 256px"
              />
            </div>
          </div>
          <v-virtual-scroll
            v-if="fileData.length > 1"
            :items="fileData.slice(1)"
            :item-height="48"
            height="400px"
            width="1090px"
            class="virtual-scroll-container"
          >
            <template v-slot:default="{ item }">
              <div
                class="d-flex justify-space-between border-bottom"
                style="height: 48px; display: flex; align-items: center"
              >
                <div
                  v-for="(cell, i) in item"
                  :key="'cell-' + i"
                  class="d-flex justify-space-between"
                  style="width: 256px; margin-right: 16px"
                >
                  <span
                    style="width: 256px"
                    class="body-regular-smaller neutral-40-light--text"
                  >
                    {{ cell }}
                  </span>
                </div>
              </div>
            </template>
          </v-virtual-scroll>
        </div>
      </div>
      <div
        class="w-full container-actions"
        :class="{ 'justify-space-end': isMobileBreakpoint }"
      >
        <base-btn type="tertiary" @click="handleClose">
          {{ $t('message.actions.cancel') }}
        </base-btn>
        <v-tooltip
          bottom
          :disabled="
            selectedFields.length > 1 &&
            fileData.length < 1000 &&
            fileData.length > 1 &&
            selectedFields.includes('private_key_column')
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <base-btn
              :disabled="
                loading ||
                selectedFields.length < 2 ||
                !selectedFields.includes('private_key_column') ||
                fileData.length > 1000 ||
                fileData.length < 2
              "
              :loading="loading"
              v-on="on"
              v-bind="attrs"
              type="primary"
              @click="uploadCsv"
            >
              {{ $t('message.pages.drm.importCsvModal.import') }}</base-btn
            >
          </template>
          <span>{{
            $t('message.pages.drm.importCsvModal.disableTooltip')
          }}</span>
        </v-tooltip>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import BaseModal from '@/components/BaseModal'
import { read, utils } from 'xlsx'
import drmApi from '@/services/drmApi'
import i18n from '@/translations/lang'
const CHUNK_SIZE = 500

export default {
  name: 'DrmUploadModal',
  components: { BaseModal },
  props: {
    selectedGroup: {
      type: Object,
    },
    accept: {
      type: Array,
      default: () => ['.csv', '.xlsx', '.xls'],
    },
  },
  data: () => ({
    isLoading: false,
    loading: false,
    fileData: [],
    minHeight: null,
    screenTitle: null,
    initialScreen: null,
    isCrispButtonVisible: true,
    file: null,
    fields: [
      {
        label: i18n.t(
          'message.pages.drm.hotmartIntegration.panel15.success.privateKey'
        ),
        value: 'private_key_column',
      },
      {
        label: i18n.t('message.pages.drm.field') + '1',
        value: 'string1_column',
      },
      {
        label: i18n.t('message.pages.drm.field') + '2',
        value: 'string2_column',
      },
      {
        label: i18n.t('message.pages.drm.field') + '3',
        value: 'string3_column',
      },
    ],
    selectedFields: [],
  }),
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    minHeight() {
      return this.isMobileBreakpoint ? '100vh' : 'auto'
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    hideCrispButton() {
      const crispButton = document.querySelector('.crisp-client')
      const crispIcon = crispButton?.querySelector('.cc-1m2mf')
      if (crispIcon && this.isMobileBreakpoint && this.isCrispButtonVisible) {
        crispIcon.style.setProperty('display', 'none', 'important')
        this.isCrispButtonVisible = false
      }
    },
    showCrispButton() {
      const crispButton = document.querySelector('.crisp-client')
      const crispIcon = crispButton?.querySelector('.cc-1m2mf')
      if (crispIcon && !this.isCrispButtonVisible) {
        crispIcon.style.removeProperty('display')
        this.isCrispButtonVisible = true
      }
    },
    isDuplicate(value, index) {
      if (!value) return false
      return (
        this.selectedFields.filter((v, i) => v === value && i !== index)
          .length > 0
      )
    },
    async uploadCsv() {
      this.loading = true
      const headers = this.fileData[0]
      const body = {}
      this.selectedFields.forEach((selectedType, index) => {
        if (selectedType) {
          body[selectedType] = headers[index]
        }
      })
      body.drm_group_id = this.selectedGroup.id
      try {
        const ret = await drmApi.uploadCsvKeyDrm(body)
        await drmApi.uploadCsvToAws(ret.data.upload_url, this.file)
        const key = `uploadCsv_${this.selectedGroup.id}`

        let existingArray = JSON.parse(localStorage.getItem(key)) || []

        existingArray.push(ret.data.import_id)

        localStorage.setItem(key, JSON.stringify(existingArray))

        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          type: 'success',
          text: this.$t('message.pages.drm.drmListKeys.importSuccess'),
        })
        this.$root.$emit('reloadTokens')
        this.$root.$emit('import-csv')
        this.handleClose()
      } catch (err) {
        console.log('err', err)
      }
    },
    async onOpenHook({ file }) {
      if (!file) return
      this.hideCrispButton()
      this.isLoading = true
      this.fileData = []
      this.file = file
      try {
        await this.processFile(file)
      } catch (error) {
        console.error('Erro ao processar arquivo:', error)
      } finally {
        this.isLoading = false
      }
    },
    onCloseHook() {
      this.showCrispButton()
      this.fileData = []
      this.file = null
      this.selectedFields = []
    },
    async processFile(file) {
      const data = await this.readFileAsArrayBuffer(file)
      const workbook = read(data, { type: 'array' })
      const worksheet = workbook.Sheets[workbook.SheetNames[0]]
      const allRows = utils.sheet_to_json(worksheet, {
        header: 1,
        raw: false,
      })

      this.processRowsInChunks(allRows)
    },

    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => resolve(new Uint8Array(e.target.result))
        reader.onerror = reject
        reader.readAsArrayBuffer(file)
      })
    },

    processRowsInChunks(allRows) {
      let index = 0

      const processChunk = () => {
        const chunkEnd = Math.min(index + CHUNK_SIZE, allRows.length)
        this.fileData = [...this.fileData, ...allRows.slice(index, chunkEnd)]
        index = chunkEnd

        if (index < allRows.length) requestAnimationFrame(processChunk)
      }

      processChunk()
    },

    handleClose() {
      this.selectedFields = []
      this.$root.$emit('closeDrmUploadModal')
    },
  },
}
</script>

<style lang="scss" scoped>
.border-bottom {
  border-bottom: 1px solid varFigma(neutral-95-lightest);
}

.virtual-scroll-container {
  margin-top: 10px;
  overflow-x: hidden !important;
  max-width: none !important;
}

.container-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid varFigma(neutral-95-lightest);
  padding: 24px;
  gap: 16px;
}

.container-content {
  overflow-x: auto;
  scroll-behavior: smooth;
  min-height: 240px;
}

.container-content::-webkit-scrollbar {
  height: 8px;
}

.container-content::-webkit-scrollbar-track {
  border-radius: 4px;
}

.container-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.container-content::-webkit-scrollbar-thumb:hover {
  background-color: varFigma(neutral-80-lighter);
}

.modal-header {
  width: 100%;
  display: flex;
  padding: 24px 12px 0 24px;
  justify-content: space-between;
}

.header-content {
  display: flex;
  flex-direction: column;
}

.file-content {
  max-height: 700px;
  min-height: 240px;
  overflow-x: hidden;
  padding-left: 20px;
  padding-right: 20px;
  border-top: 1px solid varFigma(neutral-95-lightest);
  margin-top: 24px;
}

.loading-indicator {
  padding: 16px;
  text-align: center;
}

.skeleton-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  padding: 20px;
}

.skeleton-line {
  height: 20px;
  margin-top: 10px;
  border-radius: 8px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.2s infinite;
  width: 250px;
}
.bg-dark {
  .skeleton-line {
    animation: shimmer 1.2s infinite;
    background: linear-gradient(90deg, #363949 25%, #2c2e3a 50%, #363949 75%);
  }
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}
</style>
